module.exports = __webpack_public_path__ + "static/img/Resume.318722e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/resume/Resume.jpg
// module id = R/B3
// module chunks = 1